import React from "react";
import Grid from "@material-ui/core/Grid";

import "./.Basics.css";
import Fieldset from "./Fieldset";

const Filter = ({ titulo = "Busca Rápida", inputs = [], ...props }) => {
  return (
    <Fieldset titulo={titulo} {...props}>
      {/* Não entendi o porque do marginTop:0 está funcionando (está dando margem) */}
      <Grid
        key={`grid_filter_${titulo}`}
        container
        spacing={2}
        style={{ marginTop: "0em" }}
      >
        {inputs.map((input, index) => {
          return (
            <Grid
              key={"grid_item_filter_" + index}
              item
              xs={6}
              md={4}
              lg={input.component.props.lg}
            >
              {input.component}
            </Grid>
          );
        })}
      </Grid>
    </Fieldset>
  );
};

export default Filter;
